import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './skin/assets/fonts/local-fonts.css';
import './skin/styles/Typography.css';
import './shared/styles/TabletMediaQueries.css';
import { bootstrapEnterpriseSecurity } from './enterprise/admin-shared/bootstrapSecurity';
import App from './App';
import { applyConsoleSilencer } from './shared/utils/consoleSilencer';

bootstrapEnterpriseSecurity();
applyConsoleSilencer();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
